import { FACTS } from "../facts.generated";

/**
 * The only unlabelled numbers on the site, and every one of them measured.
 *
 * This is the slot a competitor fills with a logo wall. What goes here is what we can put a
 * number on — and the numbers are **generated at build time from `memory/STATUS.md`**, which
 * the repo generates from the suites themselves.
 *
 * That matters because of what the paragraph underneath claims: *"every one of these is what
 * the suites in this repository actually report."* A hand-typed count under that sentence is
 * the one claim on the site that rots silently, and it rots in the flattering direction.
 */
export function Facts() {
  return (
    <section className="section">
      <div className="wide">
        <div className="rule">
          <span className="label">Asserted, not claimed</span>
        </div>
        <div className="facts" data-testid="facts">
          {FACTS.map((f) => (
            <div className="fact" key={f.label}>
              <strong>{f.value}</strong>
              <span>{f.label}</span>
            </div>
          ))}
        </div>
        <p className="sm muted" style={{ marginTop: "var(--s5)", maxWidth: "var(--measure)" }}>
          Every one of these is what the suites in this repository actually report, re-derived on
          each build. The fleet in the ledger above is sample data.
        </p>
      </div>
    </section>
  );
}
